import { render, staticRenderFns } from "./KshouConf.vue?vue&type=template&id=11757796"
import script from "./KshouConf.vue?vue&type=script&lang=js"
export * from "./KshouConf.vue?vue&type=script&lang=js"
import style0 from "./KshouConf.vue?vue&type=style&index=0&id=11757796&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports